export default __webpack_public_path__ + "static/media/complementary--keep-right--g1.4194a29d.png";